import i18next from 'i18next'
import { parse } from 'date-fns'
import { getLocaleStore } from '@migrate/stores'
import { LocalDate } from '@js-joda/core'
import NativeDateConverter from '@migrate/utils/date/NativeDateConverter'

const formatFor = (locale: string) => getLocaleStore().dateFnsFormatFor(locale)

export default class LocalizedDateStringConverter {
  private readonly value: string

  constructor(value: string) {
    this.value = value
  }

  public toNativeDate(locale: string = i18next.language): Date {
    return parse(this.value, formatFor(locale), new Date())
  }

  public toLocalDate(locale: string = i18next.language): LocalDate {
    return new NativeDateConverter(this.toNativeDate(locale)).toLocalDate()
  }

  public toUsFormat(locale: string = i18next.language): string {
    return new NativeDateConverter(this.toNativeDate(locale)).toUsDateString()
  }
}
